const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LIST_REGULATION_SUCCESS': {
      let index = `${
        action.meta.previousAction.campaignId
          ? action.meta.previousAction.campaignId
          : '-'
      }${
        action.meta.previousAction.catalogId
          ? action.meta.previousAction.catalogId
          : '-'
      }${
        action.meta.previousAction.vendorId
          ? action.meta.previousAction.vendorId
          : '-'
      }${
        action.meta.previousAction.regulationType
          ? action.meta.previousAction.regulationType
          : '-'
      }`

      state[index] = { result: action.payload.data }
      return state
    }
    case 'LIST_REGULATION_FAIL': {
      let index = `${
        action.meta.previousAction.campaignId
          ? action.meta.previousAction.campaignId
          : '-'
      }${
        action.meta.previousAction.catalogId
          ? action.meta.previousAction.catalogId
          : '-'
      }${
        action.meta.previousAction.vendorId
          ? action.meta.previousAction.vendorId
          : '-'
      }${
        action.meta.previousAction.regulationType
          ? action.meta.previousAction.regulationType
          : '-'
      }`
      state[index] = { result: null }
      return state
    }
    default:
      return state || initialState
  }
}



// WEBPACK FOOTER //
// ./src/features/Regulation/reducer.js